import {
  rem,
  resetCss,
  radius,
  spacing,
  token,
  tone,
} from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  resetCss,
  css`
    :host {
      background: ${token('background-secondary')};
      box-sizing: border-box;
      display: flex;
    }

    :where(.container) {
      align-content: center;
      align-items: center;
      cursor: pointer;
      display: flex;
      gap: var(--option-checkmark-spacing, ${spacing(250)});
      inline-size: 100%;
      padding: ${spacing(150)};
      user-select: none;
    }

    :where(.check) {
      background-color: ${tone('info', 'energetic')};
      border-radius: ${radius('extra-large')};
      color: ${token('foreground-inverse')};
      display: flex;
      margin-inline-start: auto;
      padding: ${spacing(50)};
    }

    :host(:hover) {
      background-color: ${token('background-tertiary')};
    }

    :host(:focus) {
      background-color: ${token('background-tertiary')};
    }

    ::slotted(img) {
      block-size: ${rem(55)};
      inline-size: ${rem(55)};
      object-fit: contain;
    }

    ::slotted(img:not([src*='http'])) {
      visibility: hidden;
    }

    :host(.hidden) {
      display: none;
    }

    :host([disabled]) {
      background: ${token('background-secondary')};
      color: ${token('albert-text-input-foreground-disabled')};

      div {
        cursor: not-allowed;
      }
    }

    :host([disabled]) ::slotted(img) {
      filter: grayscale(100%);
      opacity: 0.5;
    }
  `,
];
